import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=54266dfc&scoped=true&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"
import style0 from "./Logout.vue?vue&type=style&index=0&id=54266dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54266dfc",
  null
  
)

export default component.exports